<template>
  <h2 class="text-center">
    {{ results && results.length || 0 }} 
    {{ $t('airportlounge.results.available') }} 
    {{ temp.timeA }}
    {{ $t('airportlounge.results.on') }}
    {{ formatDate(temp.dateA, `dddd, Do MMM YYYY`) }}
  </h2>
</template>

<script>
import { get } from "vuex-pathify";
import mixins from "@/mixins";
import * as _ from "lodash";

export default {
  name: "lounge-overview",
  mixins: [mixins.format],
  computed: {
    results: get("results/products@airportlounge"),
    quote: get("quoteTemp")
  },
  data() {
    return {
      temp: {}
    }
  },
  mounted() {
    this.temp = _.cloneDeep(this.quote);
  }
};
</script>